import { subscribeToEvent } from '../tools/event-subscribe';

export function mouseTouchFrequencyCollector(onData) {
  const data = {
    count: 0,
    frequency: 0,
  };

  const startTime = Date.now();

  function handle() {
    data.count++;

    data.frequency = data.count / (Date.now() - startTime) * 1000 * 60;
    onData(data);
  }

  const subscriptions = [
    subscribeToEvent(window, 'mousedown', handle, { capture: true }),
    subscribeToEvent(window, 'touchstart', handle, { capture: true }),
  ];

  function stop() {
    subscriptions.forEach(u => u());
  }

  function toString() {
    return data.count ? `${Math.round(data.frequency)}|${data.count}` : '';
  }

  return {
    data,
    toString,
    stop,
  };
}



// WEBPACK FOOTER //
// ./src/lib/collectors/mouse-frequency.js